// taken from https://stackoverflow.com/a/30753870
var interactiveElementSelector = "\n  a[href]:not([tabindex='-1']),\n  area[href]:not([tabindex='-1']),\n  input:not([disabled]):not([tabindex='-1']),\n  select:not([disabled]):not([tabindex='-1']),\n  textarea:not([disabled]):not([tabindex='-1']),\n  button:not([disabled]):not([tabindex='-1']),\n  iframe:not([tabindex='-1']),\n  [tabindex]:not([tabindex='-1']),\n  [contentEditable=true]:not([tabindex='-1']),\n  audio[controls]:not([tabindex='-1']),\n  video[controls]:not([tabindex='-1'])\n";
export default interactiveElementSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/interactiveElementSelector/index.js
// module id = 430
// module chunks = 12